<!--suppress UnnecessaryLabelJS -->
<template>
	<div>
		<games-type
			class="mb-8"
			@choseType="updateTypeFilter"
		/>
		<table-filter
			:chosen-image-type="type"
			@search="searchText = $event"
			@chosen-tags="chosenTags = $event"
			@type="type = $event"
		/>
		<v-data-table
			:headers="headers"
			:items="gamesFiltered"
			:loading="loading"
			class="elevation-1"
			:search="searchText"
			:custom-filter="searchWithCompany"
			:mobile-breakpoint="0"
			:items-per-page="20"
			:footer-props="footerProps"
		>
			<v-progress-linear
				slot="progress"
				color="blue"
				indeterminate
			/>
			<game-row
				slot="item"
				slot-scope="props"
				:game="props.item"
				@share="$emit('share', props.item)"
				@edit="onEdit"
				@duplicate="duplicate"
			/>
		</v-data-table>
	</div>
</template>

<script>
import GameRow from "src/view/games/GameRow";
import { types } from "src/store/modules/Game.module";
import FilterAble from "src/mixins/FilterAble";
import TableFilter from "src/components/TableFilter";
import GamesType from "../home/GamesType";

export default {
	name: "GamesTable",
	components: {
		GamesType,
		GameRow,
		TableFilter,
	},
	props: { public: { default: 0 } },
	mixins: [new FilterAble(types)],
	data () {
		return {
			chosenImageType: null,
			footerProps: { "items-per-page-options": [10, 20, 50, 100] },
			loading: false,
			headers: [
				{ text: "שם", value: "name" },
				{ text: "מרכז", value: "company" },
				{ text: "סוג", value: "type" },
				{ text: "תגיות", value: "tags" },
				{ text: "פעולות", value: "", sortable: false },
			],
			search: null,
			searchText: null,
			chosenTags: [],
			showDialog: false,
			type: "",
			filters: {
				page: 1,
				public: this.public,
			},
		};
	},
	computed: {
		games () {
			return this.$store.state.GameModule.games;
		},
		gamesFiltered () {
			let filtered = this.games;
			if (this.type) {
				filtered = filtered.filter((game) => game.type_id === this.type);
			}
			if (this.chosenTags.length) {
				filtered = filtered.filter((question) => {
					const tagInChosen =
						question.tags &&
						question.tags.filter((tag) => {
							return this.chosenTags.includes(tag.id);
						}).length;
					return tagInChosen;
				});
			}
			return filtered;
		},
	},
	methods: {
		searchWithCompany (value, search, item) {
			if (typeof value === "object" && value !== null && value.name) {
				return value.name.indexOf(search) !== -1;
			} else {
				return (
					value != null &&
					search != null &&
					typeof value === "string" &&
					value.toString().indexOf(search) !== -1
				);
			}
		},
		onEdit (Game) {
			this.$emit("edit", Game);
		},
		async duplicate (game) {
			console.log(game);
			await this.$store.dispatch(types.DUPLICATE, game);
		},
		updateTypeFilter (type) {
			this.type = type.id;
		},
	},
};
</script>

<style>
.v-application .text-center {
  text-align: center !important;
}
</style>
